module.exports = __webpack_public_path__ + "static/media/banner-bironex-logo.0978b941.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner-bironex-logo.svg
// module id = 2086
// module chunks = 7